import React from 'react';
import { Clock, Shield, Award, Users } from 'lucide-react';
import { differentials } from '../../data/mock';

const iconMap = {
  Clock: Clock,
  Shield: Shield,
  Award: Award,
  Users: Users
};

const DifferentialsSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2B3990] mb-4">
            Por que escolher a Tsw Info?
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Somos referência em assistência técnica em Osasco, oferecendo qualidade, agilidade e confiança.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {differentials.map((diff) => {
            const IconComponent = iconMap[diff.icon];
            return (
              <div 
                key={diff.id}
                className="text-center p-8 bg-white rounded-2xl shadow-sm hover:shadow-lg transition-shadow"
              >
                <div className="w-20 h-20 bg-[#2B3990] rounded-full flex items-center justify-center mx-auto mb-6">
                  {IconComponent && <IconComponent size={36} className="text-[#8DC63F]" />}
                </div>
                <h3 className="text-xl font-semibold text-[#2B3990] mb-3">
                  {diff.title}
                </h3>
                <p className="text-gray-600">
                  {diff.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DifferentialsSection;